<template>
    <el-select :filterable="true" v-model="member" @change="dataChange" value-key="Key" placeholder="请选择商品" :clearable="clearable" size="small"
        @clear="dataChange" :disabled="disabled">
        <el-option v-for="item in datas" :key="item.Key" :label="item.Name" :value="item">
            <div class="proItem">
                <div class="name">{{ item.Name }}</div>
                <div class="companys">
                    <div class="company">
                        型号： {{ item.Specical }}
                    </div>
                </div>
            </div>
        </el-option>
    </el-select>
</template>
<script>
import { getAll } from "@/api/product/products";
export default {
    model: {
        prop: "value",
        event: "change",
    },
    props: {
        value: {
            default: "",
        },
        clearable: {
            default: true,
        },
        disabled: {
            default: false,
        },
        readonly: {
            default: false,
        },
    },
    data() {
        return {
            datas: [],
            member: "",
        };
    },
    watch: {
        value: {
            handler(v) {
                this.member = v;
            },
            deep: true,
            immediate: true,
        },
    },
    methods: {
        getData() {
            let param = {
                search: "",
            };
            getAll(param).then((res) => {
                if (res) {
                    this.datas = res.Items;
                }
            });
        },
        dataChange(v) {
            this.$emit("change", v);
        },
    },
    mounted() {
        this.getData();
    },
};
</script>
<style lang='scss' scoped></style>